module.exports = __webpack_public_path__ + "static/media/65.6d5c82c1.jpg";